export default {
  api: {
    list: {
      method: "get",
      url: "/device/list"
    },
    haveActivatedDevice: {
      method: "get",
      url: "/device/haveActivatedDevice"
    },
    bindLine: {
      method: "post",
      url: "/device/bindLine"
    },
    unbindLine: {
      method: "post",
      url: "/device/unbindLine"
    }
  }
};
